(function(){
  function init(){
    var berater = document.querySelector('.lj-berater');
    if(!berater || berater.dataset.ljToggle) return;
    var form = berater.querySelector('.lj-berater-form');
    if(!form) return;
    var intro = berater.querySelector('.lj-berater-intro') || berater;
    var result = berater.querySelector('.lj-berater-result');
    form.id = form.id || 'lj-berater-inhalt';
    berater.dataset.ljToggle = '1';
    var labelAuf = berater.getAttribute('data-label-open') || 'Farbberater starten';
    var labelZu = berater.getAttribute('data-label-close') || 'Farbberater schließen';
    var btn = document.createElement('button');
    btn.type = 'button';
    btn.className = 'lj-berater-toggle';
    btn.setAttribute('aria-controls', form.id);
    function setState(offen){
      berater.classList.toggle('lj-berater-zu', !offen);
      btn.setAttribute('aria-expanded', offen ? 'true' : 'false');
      btn.textContent = offen ? labelZu : labelAuf;
    }
    btn.addEventListener('click', function(){
      var offen = btn.getAttribute('aria-expanded') === 'true';
      setState(!offen);
      if(!offen){
        berater.scrollIntoView({behavior:'smooth', block:'start'});
        var ersteFrage = form.querySelector('input[type=radio]');
        if(ersteFrage) ersteFrage.focus({preventScroll:true});
      }
    });
    intro.appendChild(btn);
    setState(false);
    if(result){
      var obs = new MutationObserver(function(){
        if(!result.hidden && berater.classList.contains('lj-berater-zu')) setState(true);
      });
      obs.observe(result, {attributes:true, attributeFilter:['hidden']});
    }
  }
  if(document.readyState === 'loading'){ document.addEventListener('DOMContentLoaded', init); } else { init(); }
})();
